<template>
  <div class="dialog_box">
    <el-dialog
      title="返还工单"
      :visible="show"
      width="437px"
      @close="dialogClose"
      top="25vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_container">
        <el-form
          ref="form"
          class="form_box"
          :model="form"
          label-width="70px"
          :rules="rules"
        >
          <el-form-item label="返还人员">
            <el-input
              v-model="data.auditUser"
              placeholder="请输入理由"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="理由" prop="remark">
            <el-input
              v-model="form.remark"
              placeholder="请输入理由"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      form: {
        orderId: 0,
        remark: "",
      },
      rules: {
        remark:[{ required: true, message: "请输入返还理由", trigger: "blur" },]
      },
      imgUrl: "",
      stateList: [],
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  created() {},
  methods: {
    dialogClose() {
      this.$emit("update:show", false);
    },
    confirm(formName) {
      //
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.form.orderId = this.data.id
        this.$http.backWorkOrder(this.form).then((res) => {
          if (res.code === 0) {
            this.form = {};
            this.$parent.getList();
            this.$parent.getOrderNum();
            this.$emit("update:show", false);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
/deep/.el-dialog__body {
  overflow-y: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/views/workOrder_Admin/component/rollback.vue